export class EntityService {
}
